export class AudienceAvailabilityListModalData {
  columns = [];
  rows = [];

  setColumns(columns) {
    this.columns = columns;
  }

  getColumns() {
    return this.columns;
  }

  setRows(rows) {
    this.rows = rows;
  }

  getRows() {
    return this.rows;
  }
}

export const AGENCY_COLUMNS = [
  {
    label: 'Office',
    field: 'displayName',
  },
];

export const AGENT_COLUMNS = [
  {
    label: 'Name',
    field: (row) => `${row.firstName} ${row.lastName}`,
  },
  {
    label: 'Office(s)',
    field: (row) => {
      if (!row.agencies) return "Error display offices.";

      return row.agencies.map(agency => agency.displayName || agency.title).join(", ");
    },
  },
];
